<template>
  <div class="h-full relative overflow-y-hidden">
    <div class="h-full flex flex-col justify-between">
      <div class="">
        <RandomText class="text-[80px] px-5 z-10 text-hover" @click="infoShow">
          Núria Jordán
        </RandomText>
      </div>

      <RandomText class="text-3xl p-5 z-10 text-in" @click="infoProjects"
        >Projects</RandomText
      >
    </div>
    <horizontal-scroll
      @studioClicked="infoShow"
      @projectsClicked="infoProjects"
    ></horizontal-scroll>

    <div
      v-if="isVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-20"
    >
      <div
        class="w-1/2 shadow-2xl flex flex-col justify-between h-full"
        :style="{ backgroundColor: bgColor }"
      >
        <RandomText class="text-6xl px-6">NJ</RandomText>
        <about-info></about-info>
        <div @click="infoShow" class="flex cursor-pointer px-4">
          <Icon icon="iwwa:close" width="35px" weight="light" />
        </div>
      </div>
      <div class="w-1/2 opacity-50" :style="{ backgroundColor: bgColor }"></div>
    </div>
    <div
      v-if="projectsVisible"
      class="absolute h-full w-full flex flex-wrap top-0 left-0 overflow-hidden z-20 cursor-none"
    >
      <div class="w-1/2 shadow-2xl" :style="{ backgroundColor: bgColor }">
        <div class="flex justify-between mx-12 mt-4">
          <RandomText :class="['text-6xl', projectsVisible ? 'invisible' : '']"
            >NJ</RandomText
          >
          <div @click="infoProjects" class="flex justify-end">
            <Icon icon="iwwa:close" width="55px" weight="light" />
          </div>
        </div>
        <div class="flex flex-col pt-12 px-16">
          <div
            v-for="(item, index) in items"
            :key="index"
            class="flex items-end gap-6 cursor-none"
            @mouseover="showImage(index)"
            @mouseleave="hideImage"
          >
            <a :href="item.url" class="cursor-none flex items-center">
              <RandomText class="text-3xl px-2">{{ item.title }}</RandomText>
              <RandomText class="text-xl text-gray-400">{{
                item.subtitle
              }}</RandomText>
            </a>
          </div>
        </div>
      </div>
      <div class="h-full w-1/2">
        <div v-if="hoveredIndex !== null" class="h-full">
          <img
            :src="getImageUrl(hoveredIndex)"
            alt="Hovered Image"
            class="h-full w-full object-cover"
            loading="lazy"
          />
        </div>
        <div
          v-else
          class="opacity-50 h-full w-full"
          :style="{ backgroundColor: bgColor }"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import AboutInfo from "@/components/AboutInfo.vue";
import HorizontalScroll from "./HorizontalScroll.vue";
import RandomText from "@/components/RandomText.vue";

export default {
  components: {
    AboutInfo,
    HorizontalScroll,
    RandomText,
  },
  props: {
    bgColor: {
      type: String,
      required: true,
      default: "rgb(255, 255, 255)",
    },
  },
  mounted() {
    //console.log("Color de fondo aplicado en HomePage:", this.bgColor);
  },

  data() {
    return {
      isVisible: false,
      projectsVisible: false,
      items: [
        {
          title: "L'anòmala",
          subtitle: "Developer - Interactive design",
          url: "https://out.nurjordan.com/anomala",
        },
        {
          title: "El Modern",
          subtitle: "Developer - Interactive design",
          url: "https://out.nurjordan.com/modern",
        },
        {
          title: "Wildtech",
          subtitle: "Web developer",
          url: "https://out.nurjordan.com/wildtech",
        },
        {
          title: "Sense",
          subtitle: "Web developer",
          url: "https://out.nurjordan.com/sense",
        },
        {
          title: "Broomx",
          subtitle: "Web developer",
          url: "https://out.nurjordan.com/broomx",
        },
        {
          title: "Units x Educar",
          subtitle: "Web developer",
          url: "https://out.nurjordan.com/units",
        },
      ],
      images: [
        "/img/anomala/anomala1.png",
        "/img/modern/modern1.png",
        "/img/wildtech/wildtechmenu2.png",
        "/img/sense/sensemenu.png",
        "/img/broomx/broomxmenu.png",
        "/img/units/unitsmenu.jpg",
      ],
      hoveredIndex: null,
    };
  },
  methods: {
    infoShow() {
      this.isVisible = !this.isVisible;
    },
    infoProjects() {
      this.projectsVisible = !this.projectsVisible;
      //(this.projectsVisible);
    },
    showImage(index) {
      this.hoveredIndex = index;
    },
    hideImage() {
      this.hoveredIndex = null;
    },
    getImageUrl(index) {
      return this.images[index];
    },
  },
};
</script>

<style lang="scss" scoped>
.hiddenObject {
  display: none;
}

.text-hover {
  transition: transform 1.5s ease, font-size 1.5s ease;
}

.text-hover:hover {
  transform: translateX(40vw) scale(0.1);
}

.text-in {
  animation: fadeInOut 10s ease-in-out infinite;
}

@keyframes fadeInOut {
  0%,
  100% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
}

.z-i {
  z-index: 9999;
}
</style>